import { Component, Output, EventEmitter } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { Storage } from '../../storage/storage';

export interface ConfirmModel {
  short_description: string;
  long_description: string;
  unspsc: number;
  quantity: number;
  sup_part_num: string;
  price: number;
  url_photo: string;
  mfr_number: string;
  currency: string;
  uom: string;

}
@Component({
  selector: 'confirm',
  templateUrl: './detail-pdt.component.html'
})
export class ConfirmComponent extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel {
  short_description: string;
  long_description: string;
  unspsc: number;
  quantity: number;
  sup_part_num: string;
  price: number;
  url_photo: string;
  mfr_number: string;
  currency: string;
  uom: string;

  constructor(
    dialogService: DialogService,
    private storage: Storage) {
    super(dialogService);
    //this.dialogOptions
  }
  confirm() {
    // we set dialog result as true on click on confirm button, 
    // then we can get dialog result from caller code 
    this.result = true;
    this.close();
  }

  increment() {
    console.log('----> increment');
    // let index = this.products.indexOf(pdt);
    //console.log(this.products[index]);
    this.quantity = this.quantity + 1;
  }
  decrement() {
    console.log('----> decrement');
    // let index = this.products.indexOf(pdt);
    //console.log(this.products[index]);
    if (this.quantity > 1) {
      this.quantity = this.quantity - 1;
    }

  }
  addtocart() {
    console.log('----> addtocart called', this.quantity);
    // console.log(this.storage.cart);

    // console.log('----> pdt to add');

    // console.log(pdt);
    //this.storage.cart.push(pdt);

    let indexInCart = this.storage.cart.findIndex(item => item.sup_part_num === this.sup_part_num);

    console.log('-------> CART', this.storage.cart);
    console.log('----> pdt to update QUANTITY', this.quantity);

    //let indexInProducts = this.products.findIndex(item => item.sup_part_num === pdt.sup_part_num);



    if (indexInCart === -1) {
      this.storage.cart.push({
        short_description: this.short_description,
        sup_part_num: this.sup_part_num,
        quantity: this.quantity,
        price: this.price,
        url_photo: this.url_photo,
        mfr_number: this.mfr_number,
        id: this.sup_part_num,
        currency: this.currency,
        uom: this.uom,
        unspsc: this.unspsc
      });
    } else {
      console.log('CART -----> QUANTITY BEFORE ', this.storage.cart[indexInCart].quantity);
      console.log('PDT -----> QUANTITY BEFORE ', this.quantity);


      this.storage.cart[indexInCart].quantity = this.storage.cart[indexInCart].quantity + this.quantity;

      console.log('CART -----> QUANTITY AFTER', this.storage.cart[indexInCart].quantity);

    }

    console.log(this.quantity);

    this.quantity = 1;
    this.close();
    // this.refreshCart();
  }

}


// WEBPACK FOOTER //
// ./src/app/components/detail-pdt/detail-pdt.component.ts